import * as React from "react";
import {Link} from "react-router";
import {Categories} from "../../data/lexicorder/lexicorder";
import useSqids from "../../hooks/useSqids";

export default function LexicorderCategories() {

    const sqids = useSqids();

    return <div style={{maxWidth: "500px"}}>
        <h1 className="text-center display-1 mb-2 mb-md-4">
            <Link className="text-dark" to={"/"}>Daily Puzzles</Link>
        </h1>

        <h2>
            <Link className="text-dark" to={"/lexicorder"}>Lexicorder</Link>
        </h2>

        <p className="lead">
            Guess the word based on it's alphabetical position in the list.
        </p>

        <p>
            Pick your category:
        </p>

        <div className="list-group">
            {Categories.map((c, i) =>
                <Link key={i} to={`/lexicorder/${sqids.encode([i])}`}
                      className="list-group-item list-group-item-action">
                    <div className="d-flex justify-content-between">
                        <span>{c.name}</span>
                        <span className="badge rounded-pill text-bg-secondary">{c.entries.length}</span>
                    </div>
                    <div className="small text-secondary">{c.description}</div>
                </Link>
            )}
            <div className="list-group-item">
                More coming soon...
            </div>
        </div>
    </div>
}
